import React, { FormEvent, useEffect, useRef, useState } from "react";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import moment from "moment";
import defaultProfile from "src/assets/images/default_profile_image.png";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import {
  printServiceDuration,
  truncateString,
} from "src/helpers/helperFunctions";
import DeclineModalReason from "../AdminComponents/DeclineModalReason";
import AddAReviewModal from "../Customer/AddAReviewModal";
import { Modal, Skeleton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import modalIcon from "src/assets/images/complete-modal-icon.png";
import { appointmentSlots, CURRENCY } from "src/lib/constans";
import SimpleInput from "../SimpleInput";
import tickIcon from "src/assets/images/checked-icon-modal.png";
import HomecareAppointmentHistories from "./HomecareAppointmentHistories";
import HomecareAppointmentRequest from "./HomecareAppointmentRequest";
import { IHomecareAppointDetail } from "src/types/GlobalInterfaces";
import Cookies from "js-cookie";
import GradientBtn from "../WebsiteComponents/GradientBtn";
import CartDrawer from "../AdminComponents/CartDrawer";
import HomeCareAppointementScreen from "../AllTabs/HomeCare/HomeCareAppointementScreen";
import { Link } from "react-router-dom";
import WriteReviewModal from "../Modals/WriteReviewModal";
interface IResheduledState {
  loader: boolean;
  reason: string;
  resheduledMod: boolean;
  time: string;
  appointmentDate: string;
  daySlot: "morning" | "afternoon" | "evening" | "night";
  isSuccess: boolean;
}
const backBtnMaain: React.CSSProperties = {
  position: "absolute",
  top: -10,
  right: -10,
  backgroundColor: "red",
  borderRadius: 100,
  width: 20,
  height: 20,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const backBtn: React.CSSProperties = {
  color: "white",
};
const HomeCareAppointmentDetailComponent: React.FC<{
  appoinmentId: string;
  userRole: "customer" | "admin";
}> = ({ appoinmentId = "", userRole }) => {
  const scrollAmount = 225;
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [fileView, setFileView] = useState<null | string>(null);

  const containerStyle = {
    transform: `translateX(-${scrollPosition}px)`,
  };

  const [datesRange, setDatesRange] = useState<string[]>([]);
  const [resheduleStates, setResheduleStates] = useState<IResheduledState>({
    loader: false,
    resheduledMod: false,
    isSuccess: false,
    time: "",
    daySlot: "morning",
    appointmentDate: "",
    reason: "",
  });

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      const newPosition = Math.max(scrollPosition - scrollAmount, 0);
      setScrollPosition(newPosition);
    }
    const findIndex = datesRange.findIndex(
      (v) => v === resheduleStates.appointmentDate
    );
    setResheduleStates((prev) => ({
      ...prev,
      appointmentDate: datesRange[findIndex - 1] || "",
    }));
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      const maxScroll =
        scrollContainerRef.current.scrollWidth -
        scrollContainerRef.current.clientWidth;
      const newPosition = Math.min(scrollPosition + scrollAmount, maxScroll);
      setScrollPosition(newPosition);
    }
    const findIndex = datesRange.findIndex(
      (v) => v === resheduleStates.appointmentDate
    );
    setResheduleStates((prev) => ({
      ...prev,
      appointmentDate: datesRange[findIndex + 1] || "",
    }));
  };
  // for resheduled

  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [data, setData] = useState<IHomecareAppointDetail | null>(null);
  const [cancelState, setCancelState] = useState({
    reason: "",
    modalShow: false,
    loader: false,
  });
  const [reviewStates, setReviewStates] = useState({
    showModal: false,
    rating: 1,
    reviewMessage: "",
  });
  const [confirmComplete, setConfirmComplete] = useState<boolean>(false);
  const [completeLoader, setCompleteLoader] = useState<boolean>(false);

  const [requestAndHistory, setRequestAndHistory] = useState<{
    selectedTab: "requests" | "history";
    bool: boolean;
  }>({
    selectedTab: "requests",
    bool: false,
  });

  const closeCancel = () => {
    setCancelState({
      reason: "",
      modalShow: false,
      loader: false,
    });
  };

  const reScheduleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setResheduleStates((prev) => ({ ...prev, loader: true }));
    const { res, err } = await httpRequest({
      path: `/home-care-order/appointment/reschedule/${appoinmentId}`,
      method: "put",
      params: {
        time: resheduleStates?.time,
        appointmentDate: resheduleStates?.appointmentDate,
        reason: resheduleStates?.reason,
        daySlot: resheduleStates?.daySlot,
      },
    });
    if (res) {
      setResheduleStates((prev) => ({
        ...prev,
        reason: "",
        isSuccess: true,
      }));
      setRequestAndHistory((prev) => ({
        selectedTab: "requests",
        bool: !prev?.bool,
      }));
      setData((prev) => (prev ? { ...prev, reschedule: true } : null));
    } else {
      toast(err, { type: "error" });
    }
    setResheduleStates((prev) => ({ ...prev, loader: false }));
  };
  const completeRequest = async () => {
    setCompleteLoader(true);
    const { res, err } = await httpRequest<{ message: string }>({
      method: "put",
      path: `/home-care-order/appointment-complete/${appoinmentId}`,
      params: {},
    });
    if (res) {
      setConfirmComplete(false);
      setData((prev) => (prev ? { ...prev, status: "completed" } : null));
      toast(res?.message || "Success!", { type: "success" });
    } else {
      toast(err, { type: "error" });
    }
    setCompleteLoader(false);
  };
  const cancelRequest = async () => {
    if (!cancelState.reason) {
      toast("Kindly provide a reason for canceling the appointment.", {
        type: "error",
      });
      return;
    }
    setCancelState((prev) => ({ ...prev, loader: true }));
    const { res, err } = await httpRequest<{ message: string }>({
      method: "put",
      path: `/home-care-order/appointment-cancel/${appoinmentId}`,
      params: { cancelReason: cancelState.reason },
    });
    if (res) {
      toast(res?.message || "Success", { type: "success" });
      setData((prev) => (prev ? { ...prev, status: "cancelled" } : null));
      closeCancel();
    } else {
      toast(err, { type: "error" });
    }
    setCancelState((prev) => ({ ...prev, loader: false }));
  };
  const fetch = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IHomecareAppointDetail>({
      path: `/home-care-order/appointment/${appoinmentId}`,
    });
    if (res) {
      setData(res);
      setResheduleStates((prev) => ({
        ...prev,
        appointmentDate: res?.appointmentDate || "",
        daySlot: res?.daySlot || "morning",
        time: res?.timeslot || "",
      }));
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };
  useEffect(() => {
    fetch();
    const currentDate = moment(); // Get today's date
    const dateArray = [];
    for (let i = 0; i < 15; i++) {
      dateArray.push(currentDate.clone().add(i, "days").toISOString());
    }
    setDatesRange(dateArray);
  }, [appoinmentId]);

  const handleOpenModal = (fileUrl: string) => {
    const isPDF = fileUrl.endsWith(".pdf");
    if (isPDF) {
      window.open(`${fileUrl}`, "_blank");
    } else {
      setFileView(fileUrl);
    }
  };
  const handleCloseModal = () => {
    setFileView(null);
  };
  const ModalBtnComponent: React.FC = () => {
    return (
      <div className="flex gap-5">
        <GradientBtn
          ButtonText="Go Back"
          onPress={closeCancel}
          id="go-back-btn"
        />
        <GradientBtn
          ButtonText="Submit"
          loader={cancelState.loader}
          onPress={cancelRequest}
          id="submit-btn"
        />
      </div>
    );
  };
  return (
    <>
      {resheduleStates.isSuccess && (
        <div className="modal-stripe-overlay">
          <div className="modal-stripe p-6">
            <div className="password-update-success">
              <img src={tickIcon} alt="" />
            </div>
            <h2 className="text-[#2F2F31] leading-tight font-size-35px font-Poppins-SemiBold text-center">
              Your request to reschedule the appointment has been submitted
            </h2>
            <p className="appointment-date font-Poppins-Regular font-size-20px px-3 pt-1 pb-2 cursor-pointer">
              {`${moment(resheduleStates?.appointmentDate).format("MMM DD")}, ${
                resheduleStates?.daySlot
              }`}
            </p>
            <button
              onClick={() =>
                setResheduleStates((prev) => ({
                  ...prev,
                  isSuccess: false,
                  resheduledMod: false,
                }))
              }
              id="back-to-home-btn"
              className="back-to-home-btn text-white font-size-18px font-Poppins-SemiBold"
            >
              Back To Home
            </button>
          </div>
        </div>
      )}
      <DeclineModalReason
        title="Please specify the reason of cancellation"
        value={cancelState?.reason}
        setValue={(val: any) =>
          setCancelState((prev) => ({ ...prev, reason: val }))
        }
        isOpen={cancelState.modalShow}
        onClose={closeCancel}
        ButtonComponent={ModalBtnComponent}
      />
      {/* <AddAReviewModal
        isOpen={reviewStates.showModal}
        onSuccess={() => console.log("Success")}
        onClose={() =>
          setReviewStates({ showModal: false, rating: 1, reviewMessage: "" })
        }
        data={{
          fullName: data?.serviceName || "",
          profileImage: data?.image || "",
          serviceDuration: data?.serviceDuration || "",
          healthCareProvider: data?.healthCareProvider || "",
        }}
        appoinmentId={appoinmentId}
        comment={reviewStates.reviewMessage}
        setComment={(val: string) =>
          setReviewStates((prev) => ({ ...prev, reviewMessage: val }))
        }
        star={reviewStates.rating}
        setStar={(val: number) =>
          setReviewStates((prev) => ({ ...prev, rating: val }))
        }
        appointmentType="homecareAppointment"
        productId={data?.productId}
      /> */}
      {reviewStates.showModal && (
        <WriteReviewModal
          onClose={() =>
            setReviewStates({ showModal: false, rating: 1, reviewMessage: "" })
          }
          onSuccess={() => console.log("Success")}
          productData={
            data
              ? {
                  productId: data?.productId,
                  productName: data?.serviceName,
                  image: data?.image,
                }
              : null
          }
          productType="homeCare"
          id={appoinmentId}
        />
      )}
      <Modal
        open={confirmComplete}
        onClose={() => setConfirmComplete(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="complete-confirm-modal"
      >
        <div className="modal-container">
          <button
            onClick={() => setConfirmComplete(false)}
            className="close-btn"
          >
            <FontAwesomeIcon
              className="font-size-16px text-white"
              icon={faXmark}
              size="2x"
            />
          </button>
          <div className="text-center">
            <img
              src={modalIcon}
              className="img-fluid mx-auto"
              width={60}
              title="icon"
            />
            <h1 className="py-4 font-size-22px font-Poppins-Medium">
              Are you sure you want to complete this appointment?
            </h1>
          </div>
          <div className="flex justify-center items-center gap-3">
            <PrimaryBtn
              ButtonText="No"
              onPress={() => setConfirmComplete(false)}
              btnExtraStyle={{
                borderRadius: "100rem",
                border: "1px solid #004540",
                backgroundColor: "#fff",
                color: "#004540",
              }}
              id="no-btn"
            />
            <PrimaryBtn
              loader={completeLoader}
              onPress={completeRequest}
              ButtonText="Yes"
              btnExtraStyle={{
                borderRadius: "100rem",
                backgroundColor: "#004540",
              }}
              id="yes-btn"
            />
          </div>
        </div>
      </Modal>
      <div
        className={`table-container ${
          userRole === "customer" ? "box-design mt-0 mb-0" : "parent-box"
        }`}
      >
        {resheduleStates.resheduledMod && userRole !== "customer" ? (
          <>
            <div className="parent-box">
              {data ? (
                <div className="flex gap-4 align-start">
                  <div>
                    <img
                      alt="profile image"
                      width={80}
                      height={80}
                      className="rounded w-[10vw]"
                      src={`${data?.image}`}
                      onError={(e) => {
                        const target = e.target as HTMLImageElement; // Assert the type
                        if (target) {
                          target.src = defaultProfile;
                        }
                      }}
                    />
                  </div>
                  <div>
                    <h4 className="font-size-28px font-Poppins-SemiBold theme-color-green capitalize">
                      {data?.serviceName || "-"}
                    </h4>
                    <p className="font-size-18px font-Poppins-Regular theme-color-green">
                      {`Service Duration: ${printServiceDuration(
                        data?.serviceDuration || ""
                      )}`}
                    </p>
                    <p className="font-size-18px font-Poppins-Regular theme-color-green">
                      {`Healthcare Provider: ${
                        data?.healthCareProvider || "-"
                      }`}
                    </p>
                    <span className="font-size-18px font-Poppins-Medium text-[#393939]">
                      Fee: {CURRENCY} {data?.totalAmount || "-"}
                    </span>
                    {/* educations & degree */}
                  </div>
                </div>
              ) : (
                <div className="flex gap-4 align-start">
                  <Skeleton variant="circular" width={80} height={80} />
                  <div className="pb-8" style={{ minWidth: 200 }}>
                    <Skeleton variant="text" sx={{ fontSize: "28px" }} />
                    <Skeleton variant="text" sx={{ fontSize: "20px" }} />
                    <Skeleton variant="text" sx={{ fontSize: "20px" }} />
                  </div>
                </div>
              )}
            </div>
            <div className="parent-box">
              <div className="border-b">
                <div className="relative">
                  <button
                    disabled={
                      resheduleStates?.appointmentDate === datesRange[0]
                    }
                    className="absolute left-0 left-arrow-top-side"
                    onClick={scrollLeft}
                  >
                    <FontAwesomeIcon icon={faAngleLeft} />
                  </button>
                  <button
                    disabled={
                      resheduleStates?.appointmentDate ===
                      datesRange[datesRange?.length - 1]
                    }
                    className="absolute right-0 left-arrow-top-side"
                    onClick={scrollRight}
                  >
                    <FontAwesomeIcon icon={faAngleRight} />
                  </button>
                  <div className="overflow-x-hidden mx-8">
                    <div
                      ref={scrollContainerRef}
                      className="gap-28 mr-[7rem] flex items-start scroll-container"
                      style={containerStyle}
                    >
                      {datesRange.map((item) => (
                        <button
                          onClick={() =>
                            setResheduleStates((prev) => ({
                              ...prev,
                              appointmentDate: item,
                            }))
                          }
                          key={item}
                          className="flex-shrink-0"
                        >
                          <p
                            className={`appointment-date font-Poppins-Regular font-size-20px px-3 pt-1 pb-2 cursor-pointer ${
                              moment(item).format("DD-MM-YYYY") ===
                                moment(resheduleStates?.appointmentDate).format(
                                  "DD-MM-YYYY"
                                ) && "active"
                            }`}
                          >
                            {moment(item).format("DD MMMM")}
                          </p>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 homecare-slot-book-main">
                {appointmentSlots?.map((item) => (
                  <button
                    key={item.key}
                    className={`homecare-slot-book ${
                      resheduleStates.daySlot === item.key
                        ? "homecare-slot-book-active"
                        : ""
                    }`}
                    onClick={() =>
                      setResheduleStates((prev) => ({
                        ...prev,
                        daySlot: item.key,
                        time: item?.time,
                      }))
                    }
                  >
                    <div className="homecare-slot-book-inner">
                      <span className="font-Poppins-Medium text-[#007A71] font-size-15px capitalize">
                        {item?.title}
                      </span>
                      <p className="font-Poppins-Medium text-[#007A71] font-size-14px">
                        {item?.time}
                      </p>
                    </div>
                    <div>
                      <img src={item?.image} alt="" />
                    </div>
                  </button>
                ))}
              </div>
              <div className="py-5">
                <p className="font-Poppins-Regular font-size-20px">Reason</p>
                <form onSubmit={reScheduleSubmit}>
                  <SimpleInput
                    isRequired={true}
                    value={resheduleStates.reason}
                    onChange={(val: string) =>
                      setResheduleStates((prev) => ({ ...prev, reason: val }))
                    }
                    type="textArea"
                    rows={5}
                    isLimit={1200}
                    maxLength={1200}
                    extraStyle={{ borderColor: "#009d91" }}
                  />
                  <div className="flex justify-end mt-10">
                    <PrimaryBtn
                      loader={resheduleStates.loader}
                      type="submit"
                      ButtonText="Save"
                      btnExtraStyle={{
                        borderRadius: "1.5rem",
                        backgroundColor: "#004540",
                      }}
                      id="save-btn"
                    />
                  </div>
                </form>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="parent-box w-[100%] relative overflow-hidden rounded-[15px]">
              <div className="absolute top-0 left-0 w-full h-[35px] bg-[#00443F]"></div>
              {isLoader ? (
                <></>
              ) : data ? (
                <div className="homecare-appointment-main !z-[1]">
                  <div className="home-care-appointment-status">
                    <div
                      className={`appointment-badge ${
                        data?.status === "pending"
                          ? "pending-btn-appointment"
                          : data?.status === "completed"
                          ? "completed-btn-appointment"
                          : "cancel-btn-appointment"
                      }`}
                    >
                      <p className="text-red font-size-14px font-Poppins-SemiBold capitalize">
                        {data?.status || "-"}
                      </p>
                    </div>
                  </div>
                  <div className="profile-img-homecare-app">
                    <img alt="profile-image" src={`${data?.image}`} />
                  </div>
                  <div className="homecare-appointment-main-second mt-12">
                    <div className="homecare-appointment-main-second-inner">
                      <Link
                        to={`/homecare-services/${data?.productId}/view`}
                        className="font-Poppins-Regular font-size-16px text-[#1C1C1C]"
                      >
                        <span className="font-Poppins-Medium">
                          {truncateString(data?.serviceName || "", 100)}
                        </span>
                      </Link>
                      <p className="font-Poppins-Regular font-size-16px text-[#1C1C1C]">
                        <span className="font-Poppins-Medium">
                          Service Duration:
                        </span>{" "}
                        {printServiceDuration(data?.serviceDuration || "")}
                      </p>
                      <p className="font-Poppins-Regular font-size-16px text-[#1C1C1C]">
                        <span className="font-Poppins-Medium">
                          Healthcare Provider:
                        </span>{" "}
                        {data?.healthCareProvider || "-"}
                      </p>
                      <p className="font-Poppins-Regular font-size-16px text-[#1C1C1C]">
                        <span className="font-Poppins-Medium">Fee:</span>{" "}
                        {`${CURRENCY} ${data?.totalAmount || "-"}`}
                      </p>
                      {data?.prescription && (
                        <button
                          onClick={() => handleOpenModal(data?.prescription)}
                          className="text-[#1C1C1C] font-size-14px underline theme-color-green font-Poppins-Medium text-left w-fit"
                        >
                          View Prescription
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="homecare-appointment-main-last mt-12 ">
                    <div className="homecare-appointment-main-last-inner">
                      <p className="font-Poppins-Regular font-size-16px text-[#1C1C1C]">
                        <span className="font-Poppins-Medium">
                          Patient Name:
                        </span>{" "}
                        {data?.patientName || "-"}
                      </p>
                      <p className="font-Poppins-Regular font-size-16px text-[#1C1C1C]">
                        <span className="font-Poppins-Medium">
                          Phone Number:
                        </span>{" "}
                        {data?.phoneNumber || "-"}
                      </p>
                      <p className="font-Poppins-Regular font-size-16px text-[#1C1C1C]">
                        <span className="font-Poppins-Medium">Date:</span>{" "}
                        {moment(data?.appointmentDate)?.format("MMMM DD, YYYY")}
                      </p>
                      <p className="font-Poppins-Regular font-size-16px text-[#1C1C1C]">
                        <span className="font-Poppins-Medium">Time:</span>{" "}
                        {data?.timeslot || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            <div className="flex w-[100%] items-center justify-center gap-4 mt-[20px] mb-[10px]">
              {userRole === "customer" && data?.status === "pending" && (
                <GradientBtn
                  disabled={data?.reschedule}
                  title={data?.reschedule ? "Already request exist." : ""}
                  extraClass={data?.reschedule ? "cursor-not-allowed" : ""}
                  type="button"
                  onPress={() =>
                    setResheduleStates((prev) => ({
                      ...prev,
                      resheduledMod: true,
                    }))
                  }
                  ButtonText="Reschedule"
                  id="review-btn"
                />
              )}
              {data?.status === "pending" && (
                <GradientBtn
                  type="button"
                  ButtonText="Cancel"
                  onPress={() =>
                    setCancelState((prev) => ({ ...prev, modalShow: true }))
                  }
                />
              )}
              {userRole === "customer" && data?.status === "completed" && (
                <GradientBtn
                  type="button"
                  ButtonText="Review"
                  onPress={() =>
                    setReviewStates((prev) => ({ ...prev, showModal: true }))
                  }
                  id="complete-btn"
                />
              )}
              {userRole === "admin" && (
                <GradientBtn
                  disabled={data?.status === "pending" ? false : true}
                  type="button"
                  ButtonText="Complete"
                  onPress={() => setConfirmComplete(true)}
                  id="complete-btn"
                />
              )}
            </div>
            <div className="border-b border-[#707070] pb-6 w-[100%]">
              <div className="flex gap-2">
                <button
                  id="request-btn"
                  onClick={() =>
                    setRequestAndHistory((prev) => ({
                      ...prev,
                      selectedTab: "requests",
                    }))
                  }
                  className={`font-Poppins-SemiBold font-size-20px py-1 px-3 text-center ${
                    requestAndHistory?.selectedTab === "requests"
                      ? "theme-color-green border-b-[5px] border-[#00443F]"
                      : ""
                  }`}
                >
                  Request
                </button>
                <p className="text-3xl text-[#aeaeae]">|</p>
                <button
                  id="history-btn"
                  onClick={() =>
                    setRequestAndHistory((prev) => ({
                      ...prev,
                      selectedTab: "history",
                    }))
                  }
                  className={`font-Poppins-SemiBold font-size-20px py-1 px-3 text-center ${
                    requestAndHistory?.selectedTab === "history"
                      ? "theme-color-green border-b-[5px] border-[#00443F]"
                      : ""
                  }`}
                >
                  History
                </button>
              </div>
            </div>
            {requestAndHistory?.selectedTab === "requests" ? (
              <HomecareAppointmentRequest
                bool={requestAndHistory?.bool}
                appointmentId={appoinmentId}
                // appointmentId={data?.productId}
                userRole={userRole}
                setMainData={setData}
                onChangeStatus={() =>
                  setRequestAndHistory((prev) => ({
                    ...prev,
                    selectedTab: "history",
                  }))
                }
              />
            ) : (
              <HomecareAppointmentHistories
                bool={requestAndHistory?.bool}
                appointmentId={appoinmentId}
                // appointmentId={data?.productId}
              />
            )}
          </>
        )}

        {userRole === "customer" && (
          <CartDrawer
            isOpen={resheduleStates.resheduledMod}
            onClose={() =>
              setResheduleStates((prev) => ({ ...prev, resheduledMod: false }))
            }
          >
            <HomeCareAppointementScreen
              id={data?.productId}
              isEdit={true}
              editData={data}
              onBack={() =>
                setResheduleStates((prev) => ({
                  ...prev,
                  resheduledMod: false,
                }))
              }
              onSuccess={() =>
                setResheduleStates((prev) => ({
                  ...prev,
                  resheduledMod: false,
                }))
              }
            />
          </CartDrawer>
        )}

        {fileView && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[999]"
            onClick={handleCloseModal}
          >
            <div
              className="Prescription-modal-voice"
              onClick={(e) => e.stopPropagation()} // Prevent close when clicking inside the modal
            >
              <button onClick={handleCloseModal} style={backBtnMaain}>
                <FontAwesomeIcon
                  className="font-size-16px "
                  icon={faXmark}
                  size="2x"
                  style={backBtn}
                />
              </button>
              <img src={`${fileView}`} alt="Prescription" className="" />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default HomeCareAppointmentDetailComponent;
